import React, { ReactNode } from "react";
import { IntlShape, useIntl } from "react-intl";

import fr from "../locales/fr-FR.json";

type Concat<K extends string, P extends string> = `${K}${"" extends P
  ? ""
  : "."}${P}`;

type DeepKeys<T> = T extends Record<string, unknown>
  ? {
      [K in keyof T]-?: `${K & string}` | Concat<K & string, DeepKeys<T[K]>>;
    }[keyof T]
  : "";

type DeepLeafKeys<T> = T extends Record<string, unknown>
  ? { [K in keyof T]-?: Concat<K & string, DeepKeys<T[K]>> }[keyof T]
  : "";

export const formatOptions = {
  sup: (str) => <sup key={str}>{str}</sup>,
  b: (str) => (
    <span style={{ fontWeight: "bold" }} key={str}>
      {str}
    </span>
  ),
};

const useTranslations = (options?: any) => {
  const { formatMessage: t } = useIntl();

  return <ID extends DeepLeafKeys<typeof fr>>(
    id: ID,
    options?: Parameters<IntlShape["formatMessage"]>["1"]
  ): string | ReactNode | number =>
    t(
      { id },
      {
        ...formatOptions,
        ...options,
      }
    );
};

export default useTranslations;
